/* hs-eslint ignored failing-rules */

'use es6';

import { omit } from 'underscore';
import LanguageSelect from 'ui-addon-i18n/components/LanguageSelect';
import useContentSupportedLanguages from '../../hooks/useFetchContentSupportedLanguages';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentSupportedLanguageSelect(props) {
  const {
    contentSupportedLanguages,
    isLoading
  } = useContentSupportedLanguages();
  return /*#__PURE__*/_jsx(LanguageSelect, Object.assign({
    error: !isLoading && undefined,
    isLoading: isLoading
  }, props, {
    validLanguages: contentSupportedLanguages
  }));
}
ContentSupportedLanguageSelect.propTypes = Object.assign({}, omit(LanguageSelect.PropTypes, 'validLanguages'));